import AbstractWidgetNotificationsCollection from './YPAbstractWidgetNotificationsCollection';
import TimesheetNotification from './YPTimesheetNotificationObject';

export default class RosterNotifications extends AbstractWidgetNotificationsCollection {
  constructor(notifications) {
    super(notifications, 'timesheetPublishedUntil', (notification) =>
      notification.notificationMessages.map(
        (notificationMessage) =>
          new TimesheetNotification(
            notification.id,
            notification.timestamp,
            notification.isRead,
            notificationMessage
          )
      )
    );
  }
}
